import { eq } from 'tio-ui/utilities';
import type { TASAssistanceHistoryType } from '../../../types/tuition-assistance';
import type { TOC } from '@ember/component/template-only';
import {
  PhCheck,
  PhCurrencyCircleDollar,
  PhThumbsDown,
  PhThumbsUp,
  PhUser,
  PhFile,
} from 'ember-phosphor-icons';

export type ItemSignature = {
  approverName?: string;
  approverComment?: string;
  date: string;
  details?: string;
  icon?: string;
  iconBackground?: string;
  manner?: string;
  paymentState?: string;
  amount?: number;
  assistanceType?: TASAssistanceHistoryType;
};

export interface FeedSignature {
  Args: {
    feed: ItemSignature[];
  };
  Blocks: {
    record: [feed: ItemSignature];
    comment: [feed: ItemSignature];
  };
  Element: HTMLDivElement;
}

const FeedContainer: TOC<FeedSignature> = <template>
  <div class="flow-root" ...attributes>
    <ul role="list" class="flex flex-col gap-y-6 !overflow-hidden">
      {{#each @feed as |item|}}
        <li>
          <div class="relative flex gap-2">
            <div class="tio-flex-center absolute -bottom-40 left-0 top-0 w-8">
              <div class="w-px bg-gray-200 dark:bg-gray-600"></div>
            </div>
            <div class="tio-row-center relative">
              {{#if item.icon}}
                <span
                  class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-400 ring-8 ring-white
                    {{item.iconBackground}}"
                >
                  {{#if (eq item.icon "CheckIcon")}}
                    <PhCheck @size="20" class="tio-fg-inverse" aria-hidden="true" />
                  {{else if (eq item.icon "HandThumbUpIcon")}}
                    <PhThumbsUp @size="20" class="tio-fg-inverse" aria-hidden="true" />
                  {{else if (eq item.icon "HandThumbDownIcon")}}
                    <PhThumbsDown @size="20" class="tio-fg-inverse" aria-hidden="true" />
                  {{else if (eq item.icon "UserIcon")}}
                    <PhUser @size="20" class="tio-fg-inverse" aria-hidden="true" />
                  {{else if (eq item.icon "Document")}}
                    <PhFile @size="20" class="tio-fg-inverse" aria-hidden="true" />
                  {{else if (eq item.icon "CurrencyDollar")}}
                    <PhCurrencyCircleDollar @size="20" class="tio-fg-inverse" aria-hidden="true" />
                  {{/if}}
                </span>
              {{else}}
                <div class="rounded-full ring-8 ring-white">
                  <div
                    class="ml-3 h-2 w-2 rounded-full tio-bg-sunken dark:bg-gray-600 ring-1 ring-gray-300 dark:ring-gray-500 mr-3"
                  ></div>
                </div>
              {{/if}}
            </div>
            {{yield item to="record"}}

          </div>
          {{yield item to="comment"}}
        </li>
      {{/each}}
    </ul>
  </div>
</template>;

export default FeedContainer;
